
import { Base } from '../base-component';

import './deals-blue-block-add-on.component.scss';

export class DealsBlueBlockAddOn extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/deals-blue-block-add-on/deals-blue-block-add-on.component.ts